module.exports = {"pi":{"clientId":"0XDjm99GjbtlUJWkclfsay2EMX6aS0hC"},"identity":{"baseUrl":"https://collectionsapi.prd-prsn.com/api/identity/v1"},"contentService":{"baseUrl":"https://collectionsapi.prd-prsn.com/api/content/v1"},"collectionService":{"baseUrl":"https://collectionsapi.prd-prsn.com/api/collection/v1"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/prod.config.json
// module id = 274
// module chunks = 0